import {List, ListItem, ListItemButton, ListItemText, Stack, Typography} from "@mui/material";
import {ItemPaper} from "../WeaponBuilder";
import ShareLoadout from "../share/ShareLoadout";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Remove';
import RemoveIcon from '@mui/icons-material/Close';

import {displayAttachmentName, displaySlotName, slotsFull} from "./Attachments";
import {useState} from "react";
import {AttachmentEffects} from "../share/AttachmentsSummary";
import {Delete} from "@mui/icons-material";

function MobileAttachments({
                                   selectedWeapon,
                                   selectedAttachments,
                                   availableAttachments,
                                   handleAttachmentSelection,
                                   removeAttachment,
                                   dialogOpen,
                                   setDialogOpen
                               }) {
    const [openSlot, setOpenSlot] = useState()

    const toggleSlot = (slot) => openSlot === slot ? setOpenSlot(null) : setOpenSlot(slot)

    return (
        <ItemPaper>
            <Stack sx={{height: '100%', width: '100%', position: 'relative', overflow: 'hidden'}}>
                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                    <Typography variant='h6' sx={{pl: '5px'}}>Attachments</Typography>
                    {selectedWeapon == null ? null :
                        <ShareLoadout weapon={selectedWeapon} attachments={selectedAttachments} open={dialogOpen}
                                      setOpen={setDialogOpen}/>
                    }
                </Stack>
                {selectedWeapon == null ?
                    <Typography textAlign='center'>Select a weapon to view attachments</Typography> :
                    <List dense sx={{
                        width: '100%',
                        height: '100%',
                        maxWidth: 360,
                        overflow: 'hidden',
                    }}>
                        {Object.keys(availableAttachments)
                            .filter((slot) => availableAttachments[slot]?.length > 0)
                            .map((slot) =>
                                <ListItem key={`item-attachment-${slot}`}
                                          sx={{
                                              flexDirection: 'column',
                                          }}>
                                    <Stack direction='row' justifyContent='space-between'
                                           alignItems='center' width='100%'>
                                        <ListItemText
                                            primary={`${displaySlotName(slot)}${selectedAttachments[slot] != null ? ' - ' + displayAttachmentName(selectedAttachments[slot]) : ''}`}/>
                                        {openSlot === slot ?
                                            <CloseIcon onClick={() => toggleSlot(slot)}/> :
                                            selectedAttachments[slot] != null ?
                                                <RemoveIcon onClick={() => removeAttachment(slot)}/> :
                                                slotsFull(selectedAttachments) ? null :
                                                    <AddIcon onClick={() => toggleSlot(slot)}/>}
                                    </Stack>
                                </ListItem>
                            )}
                    </List>
                }
                {
                    openSlot != null ?
                        <Stack sx={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            borderRadius: '5px',
                            backgroundColor: 'background.paper',
                            zIndex: 5
                        }}>
                            <Stack sx={{
                                width: '100%',
                                flexDirection: 'row',
                                justifyContent: 'end',
                                zIndex: 6,
                                position: 'absolute'
                            }}>
                                <RemoveIcon color='white' onClick={() => toggleSlot(openSlot)}/>
                            </Stack>
                            <List sx={{
                                p: 0,
                                height: '100%',
                                overflowY: 'scroll',
                                '&::-webkit-scrollbar': {display: 'none'}
                            }}>
                                {availableAttachments[openSlot].map((attachment) => (
                                    <ListItemButton
                                        selected={selectedAttachments[openSlot] === attachment}
                                        onClick={() => {
                                            handleAttachmentSelection(attachment, openSlot);
                                            toggleSlot(openSlot)
                                        }}
                                        sx={{p: 0}}
                                    >
                                        <ListItem sx={{
                                            flexDirection: 'column',
                                            alignItems: 'start',
                                            m: '5px 10px',
                                            p: '10px',
                                            backgroundColor: 'rgb(100,100,100,0.1)',
                                            borderRadius: '5px'
                                        }}
                                                  key={`item-attachment-${openSlot}-${(displayAttachmentName(attachment))}`}>
                                            <ListItemText sx={{alignSelf: 'center', fontSize: '1rem', m: 0}}
                                                          primary={displayAttachmentName(attachment)}/>
                                            <AttachmentEffects effects={attachment.effects} fontSize='0.7rem'/>
                                        </ListItem>
                                    </ListItemButton>
                                ))}
                            </List>
                        </Stack> : null
                }
            </Stack>
        </ItemPaper>
    )
}

export default MobileAttachments;
